import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllReferralUsers,
  deleteReferralUser,
} from "../thunks/referralThunks";

const initialState = {
  allReferralUsers: {
    referrals: [],
    pagination: {},
    loading: false,
    error: null,
  },
  deleteStatus: {
    isDeleting: false,
    error: null,
  },
};

const referralSlice = createSlice({
  name: "referral",
  initialState,
  extraReducers: (builder) => {
    // FETCH ALL REFERRAL USERS
    builder
      .addCase(fetchAllReferralUsers.pending, (state) => {
        state.allReferralUsers.loading = true;
        state.allReferralUsers.error = null;
      })
      .addCase(fetchAllReferralUsers.fulfilled, (state, action) => {
        state.allReferralUsers.loading = false;
        // Handle both response formats
        const data = action.payload.data || action.payload;
        state.allReferralUsers.referrals = data.referrals || [];
        state.allReferralUsers.pagination = data.pagination || {};
      })
      .addCase(fetchAllReferralUsers.rejected, (state, action) => {
        state.allReferralUsers.loading = false;
        state.allReferralUsers.error = action.payload || "Failed to fetch referral users";
      });

    // DELETE REFERRAL USER
    builder
      .addCase(deleteReferralUser.pending, (state) => {
        state.deleteStatus.isDeleting = true;
        state.deleteStatus.error = null;
      })
      .addCase(deleteReferralUser.fulfilled, (state, action) => {
        state.deleteStatus.isDeleting = false;
        state.allReferralUsers.referrals = state.allReferralUsers.referrals.filter(
          (user) => user._id !== action.payload
        );
      })
      .addCase(deleteReferralUser.rejected, (state, action) => {
        state.deleteStatus.isDeleting = false;
        state.deleteStatus.error = action.payload || "Failed to delete referral user";
      });
  },
});

export default referralSlice.reducer;